import * as React from 'react'
import { PageInfo } from '../../types'
import { Pagination } from 'plume-ui'
import Link from 'next/link'
import uniq from 'lodash/uniq'
import { css } from '@emotion/react'

type Props = {
  link: {
    href: string
    as?: string
  }
} & PageInfo

export const PaginationFromPageInfo: React.FC<Props> = (props) => {
  const total = Math.ceil(props.count / props.limit)
  const current = Math.floor(props.offset / props.limit)

  return props.count ? (
    <div
      css={css`
        display: flex;
        justify-content: center;
        margin-top: 1.5rem;
      `}
    >
      <Pagination>
        <Prev
          disabled={current === 0}
          href={`${props.link.href}&limit=${props.limit}&offset=${
            props.offset - props.limit
          }`}
          as={`${props.link.as}?limit=${props.limit}&offset=${
            props.offset - props.limit
          }`}
        />
        <Pagination.List>
          {pageNumbers(total, current).map((p, i) => (
            <React.Fragment key={i}>
              {p === -1 ? (
                <Pagination.Ellipsis />
              ) : (
                <Pagination.Item key={p} active={current === p}>
                  <Link
                    href={`${props.link.href}&limit=${props.limit}&offset=${
                      props.limit * p
                    }`}
                    as={`${props.link.as}?limit=${props.limit}&offset=${
                      props.limit * p
                    }`}
                    passHref
                  >
                    <a>{p + 1}</a>
                  </Link>
                </Pagination.Item>
              )}
            </React.Fragment>
          ))}
        </Pagination.List>
        <Next
          disabled={current === total - 1}
          href={`${props.link.href}&limit=${props.limit}&offset=${
            props.offset + props.limit
          }`}
          as={`${props.link.as}?limit=${props.limit}&offset=${
            props.offset + props.limit
          }`}
        />
      </Pagination>
    </div>
  ) : null
}

const Prev: React.FC<{
  disabled: boolean
  href: string
  as?: string
}> = (props) => {
  return props.disabled ? (
    <Pagination.Previous as="span" disabled />
  ) : (
    <Link href={props.href} as={props.as}>
      <Pagination.Previous />
    </Link>
  )
}

const Next: React.FC<{
  disabled: boolean
  href: string
  as?: string
}> = (props) => {
  return props.disabled ? (
    <Pagination.Next as="span" disabled />
  ) : (
    <Link href={props.href} as={props.as}>
      <Pagination.Next />
    </Link>
  )
}

const FIXED_COUNT = 2
const MID_COUNT = 1

export const pageNumbers = (total: number, currnet: number): number[] => {
  const head = range(FIXED_COUNT)
  const mid = range(MID_COUNT * 2 + 1, currnet - MID_COUNT)
  const tail = range(FIXED_COUNT, total - FIXED_COUNT)

  const list = uniq([...head, ...mid, ...tail]).filter(
    (v) => v >= 0 && v < total
  )
  return insertEllipsis(list)
}

function insertEllipsis(list: number[]): number[] {
  const ret = [...list]
  for (let i = 0; i < ret.length - 1; i++) {
    if (ret[i + 1] - ret[i] !== 1) {
      ret.splice(i + 1, 0, -1)
      i += 1
    }
  }
  return ret
}

const range = (n: number, start: number = 0): number[] => {
  const list: number[] = []
  for (let i = start; i < start + n; i++) {
    list.push(i)
  }
  return list
}
